module.exports = __webpack_public_path__ + "img/ctrl-p-stub-up-+.38a64a5c.svg";